import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/storage-for-winter.jpg'),
    alt: 'storage for winter page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'storage for winter page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Reliable <span>Storage</span><span>Solutions for Winter</span>',
  description:
    'Get ready for winter with our affordable storage. Store seasonal items, gear, or belongings safely in our secure facilities until you need them again.',
  image: {
    url: '/images/v2/pages/landing-pages/storage-for-winter/hero-image.jpg',
    alt: 'Reliable Storage Solutions for Winter'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Register for Winter Storage' }
}

export const ourProcessSectionContent = {
  title: 'How Winter Storage Works',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' },

  image: {
    url: '/images/v2/pages/landing-pages/storage-for-winter/how-winter-storage-works.png',
    alt: 'How Winter Storage Works'
  },

  articles: [
    {
      id: 1,
      title: 'Simple Scheduling',
      description:
        'Reserve your storage space easily online and schedule a convenient pickup date for your winter items.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-for-winter/simple-scheduling.png',
        alt: 'Simple Scheduling'
      }
    },
    {
      id: 2,
      title: 'Safe and Secure Storage',
      description:
        'Keep your winter gear and belongings in our secure storage units, monitored 24/7 to ensure they are safe from theft or damage.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-for-winter/safe-and-secure-storage.png',
        alt: 'Safe and Secure Storage'
      }
    },
    {
      id: 3,
      title: 'Easy Access',
      description:
        'Access your items as needed with flexible hours, making it convenient to retrieve or add items throughout the winter season.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-for-winter/easy-access.png',
        alt: 'Easy Access'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Affordable Winter Storage Services',
  description:
    'At ShipAndStorage, we offer specialized storage solutions tailored for the winter months. From clothing and seasonal decorations to outdoor equipment and winter sports gear, our secure storage options ensure everything is safe and ready when you need it.',
  image: {
    src: '/images/v2/pages/landing-pages/storage-for-winter/affordable-winter-storage-services.jpg',
    alt: 'Affordable Winter Storage Services'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Using Winter Storage',

  cards: [
    {
      id: 1,
      title: 'Affordable Winter Storage Plans',
      description:
        'We provide cost-effective winter storage plans, allowing you to store your items without exceeding your budget.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-for-winter/affordable-winter-storage-plans.png',
        alt: 'Affordable Winter Storage Plans'
      }
    },
    {
      id: 2,
      title: 'No Long-Term Commitments',
      description:
        'Only pay for the duration of time you need storage, with flexible rental terms tailored to your winter storage needs.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-for-winter/no-long-term-commitments.png',
        alt: 'No Long-Term Commitments'
      }
    },
    {
      id: 3,
      title: 'Weatherproof Storage Units',
      description:
        'Our facilities are designed to protect your items from the harsh winter elements, keeping them in optimal condition.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-for-winter/weatherproof-storage-units.png',
        alt: 'Weatherproof Storage Units'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Choose Winter Storage Solutions?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Homeowners Preparing for Winter',
          description:
            'Store your summer furniture, decorations, or outdoor equipment in preparation for the colder months.'
        },
        {
          id: 2,
          title: 'Students Going Home for the Holidays',
          description:
            'Secure your dorm or apartment items during winter break with our affordable, short-term storage options.'
        },
        {
          id: 3,
          title: 'Winter Sports Enthusiasts',
          description:
            'Store your skis, snowboards, and other gear in a safe, secure location until the next winter season.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/storage-for-winter/who-should-choose-winter-storage-solutions.jpg',
        alt: 'Who Should Choose Winter Storage Solutions?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Explore Our Additional Storage Solutions',

  cards: [
    {
      id: 1,
      title: 'Business Storage Solutions',
      description:
        'Affordable and secure storage for businesses during the winter season, whether it’s inventory, equipment, or documents.',
      image: {
        src: '/images/v2/pages/common/business-storage-solution.png',
        alt: 'Business Storage Solutions'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Business Storage' }
    },
    {
      id: 2,
      title: 'Moving Storage Solution',
      description: 'Moving during the winter months? Store your items securely while navigating your transition.',
      image: {
        src: '/images/v2/pages/common/moving-storage-solution.png',
        alt: 'Moving Storage Solution'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Moving Storage' }
    },
    {
      id: 3,
      title: 'Luggage and Box Shipping Services',
      description: 'Ship your luggage or boxes, whether it’s winter clothing or gifts, locally and internationally.',
      image: {
        src: '/images/v2/pages/common/luggage-and-box-shipping-services.png',
        alt: 'Luggage and Box Shipping Services'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Box Storage' }
    },
    {
      id: 4,
      title: 'Residential Storage Services',
      description:
        'Store your winter clothing, seasonal decorations, and other household items with our secure residential storage solutions.',
      image: {
        src: '/images/v2/pages/common/residential-storage-services.png',
        alt: 'Residential Storage Services'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Residential Storage' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose ShipAndStorage for Winter Storage?',

  image: {
    url: '/images/v2/pages/landing-pages/storage-for-winter/why-choose-shipandstorage-for-winter-storage.jpg',
    alt: 'Why Choose ShipAndStorage for Winter Storage?'
  },

  articles: [
    {
      id: 1,
      title: 'Convenient Online Booking',
      description: 'Easily reserve your winter storage space online and choose your pick-up date with no hassle.'
    },
    {
      id: 2,
      title: 'Flexible Storage Options',
      description:
        'Whether you’re storing a few boxes or large outdoor equipment, we offer a variety of storage unit sizes to fit your needs.'
    },
    {
      id: 3,
      title: 'Affordable Winter Pricing',
      description:
        'Our winter storage services are designed to be cost-effective, providing you with the best value for secure, monitored storage.'
    },
    {
      id: 4,
      title: 'Fast and Reliable Access',
      description:
        'Access your stored winter items whenever you need them, with flexible hours and reliable customer service.'
    },
    {
      id: 5,
      title: 'Safe and Secure Facilities',
      description:
        'Rest assured that your winter items are protected in our climate-controlled, monitored storage units.'
    },
    {
      id: 6,
      title: 'Tailored for Winter Needs',
      description:
        'Our winter storage solutions are customized to meet the demands of cold-weather items like coats, boots, and sports gear.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Reliable Winter Storage Solutions for Students',
  description:
    'Reliable storage for winter students and travelers. Affordable, secure solutions for storing your belongings during the winter season.',
  image: {
    src: '/images/v2/pages/landing-pages/storage-for-winter/reliable-winter-storage-solutions-for-students.png',
    alt: 'Reliable Winter Storage Solutions for Students'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Get Started with Winter Storage Today' }
}

export const ourPartnersSectionContent = {
  description:
    'ShipAndStorage partners with top global shipping and logistics providers to offer secure and reliable storage solutions.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'FedEx provides secure logistics and storage services, ensuring that your items are safely stored and transported, no matter the weather.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL ensures reliable storage and shipping services, taking extra care with your winter items to guarantee they are delivered safely.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy of the information provided. For more information, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'UPS offers secure storage options and safe, reliable delivery, ensuring that your winter belongings are stored and shipped without a hitch.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.ups.com/' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
